<template>
  <!--New Design-->
  <div style="color: #000;">
    <div class="d-flex justify-content-center align-items-center">
      <h3>{{ title }}</h3>
    </div>

    <section
      v-for="(category, categoryindex) in ComboPackArray"
      :key="categoryindex"
      class=""
    >
      <h6
        class="my-3"
        v-bind:class="langName == 'ar' ? 'text-right' : ''"
        style="font-weight: bold;"
        >{{
          langName != "ar"
            ? category.category_name
            : category.alternate_category_name
            ? category.alternate_category_name
            : category.category_name
        }}&nbsp;
        <span style="color: #cf1f2e !important;">
          ({{ getComboQtyText(categoryindex) }})</span
        ></h6
      >
      <div
        class="d-flex justify-content-between align-items-center pb-2 mb-2 pl-2"
        style="border-bottom: .5px dashed #789;"
        v-for="(food, index) in category.combo_items"
        :key="index"
      >
        <div>
          <p class="mb-0">{{
            langName != "ar"
              ? food.item_name
              : food.alternate_lang_item_name
              ? food.alternate_lang_item_name
              : food.item_name
          }}</p>
        </div>
        <div class="combo_qty">
          <div
            class="combo_icon"
            @click.prevent.stop="
              onChangeComboItems(food, index, category, categoryindex, 'minus')
            "
          >
            <a> -</a>
          </div>
          <div class="combo_num ar-number">{{ food.quantity }}</div>
          <div
            class="combo_icon"
            @click.prevent.stop="
              onChangeComboItems(food, index, category, categoryindex, 'add')
            "
          >
            <a> +</a>
          </div>
        </div>
      </div>
    </section>
    <div class="d-flex justify-content-between align-items-center mt-2">
      <button class="modal_combo_cancel_btn" @click="onCloseCombPopup">{{
        allLanguageData.PopupTerms.CancelButton
      }}</button>
      <button class="modal_combo_btn" @click="onSaveComboChanges">{{
        allLanguageData.AddtoCart
      }}</button>
    </div>
  </div>
</template>
<script>
// import FoodMark from "@/components/UIElements/VegMark.vue";

export default {
  name: "AlternativeItems",
  components: {
    // FoodMark,
  },
  props: {
    refId: {
      type: String,
      default: "comboPackModal",
    },
    title: {
      type: String,
      default: "",
    },
    comboIndex: {
      type: Number,
      default: null,
    },
    ComboPackArray: {
      type: Array,
      default: [],
    },
    onSaveComboPack: { type: Function },
    checkCustomization: { type: Function },
    openPopup: { type: Boolean, default: true },
  },
  data() {
    return {
      smCardView: true,
    };
  },
  computed: {},
  beforeMount() {},
  methods: {
    onCloseCombPopup() {
      let payload = {
        close: true,
      };
      this.$emit("onCloseCombPopup", true);
      // this.$bvModal.hide("comboPackModal");
    },
    getComboItemSelectedByCategory(categoryIndex) {
      let totalCount = 0;
      this.ComboPackArray[categoryIndex].combo_items.forEach((x) => {
        totalCount += x.quantity;
      });
      return totalCount;
    },
    getComboQtyText(categoryIndex) {
      let selectedCategory = {
        min_max_setting: "N",
        min_quantity: 0,
        max_quantity: 0,
        quantity: 0,
      };
      Object.keys(selectedCategory).map((key) => {
        selectedCategory[key] =
          this.ComboPackArray[categoryIndex][key] || selectedCategory[key];
      });
      let text = ``;
      if (selectedCategory["min_max_setting"] == "Y") {
        text = `Min Qty. ${selectedCategory["min_quantity"]} & Max Qty. ${
          selectedCategory["max_quantity"]
        }`;
      } else {
        this.langName == "ar"
          ? (text = `حدد على الأقل ${selectedCategory["quantity"]} كمية 
`)
          : (text = `Select Atleast ${selectedCategory["quantity"]} Quantity`);
      }
      return text;
    },
    onChangeComboItems(food, index, category, categoryindex, type) {
      let totalItemSelected = this.getComboItemSelectedByCategory(
        categoryindex
      );
      if (type == "add") {
        if (category["min_max_setting"] == "Y") {
          if (totalItemSelected >= category.max_quantity) {
            if (
              this.ComboPackArray[categoryindex].combo_items[index].quantity >=
              category.max_quantity
            ) {
              this.langName == "ar"
                ? this.$toasted.show(
                    `تم اختيار العدد الأقصى من الكمية لهذه الفئة`
                  )
                : this.$toasted.show("All items Selected for this category");
            }

            let sortedArray = [
              ...this.ComboPackArray[categoryindex].combo_items,
            ]
              .filter((x) => x.item_id != food.item_id)
              .sort((a, b) => b.quantity - a.quantity);

            for (const _item of sortedArray) {
              let checkIndex = this.ComboPackArray[
                categoryindex
              ].combo_items.findIndex(
                (_c_item) => _c_item.item_id == _item.item_id
              );
              if (
                checkIndex > -1 &&
                this.ComboPackArray[categoryindex].combo_items[checkIndex]
                  .quantity > 0
              ) {
                this.ComboPackArray[categoryindex].combo_items[checkIndex]
                  .quantity--;
                this.ComboPackArray[categoryindex].combo_items[index]
                  .quantity++;
                break;
              }
            }
            // this.$toasted.show("All items Selected for this category");
          } else {
            this.ComboPackArray[categoryindex].combo_items[index].quantity++;
          }
        } else {
          if (totalItemSelected >= category.quantity) {
            if (
              this.ComboPackArray[categoryindex].combo_items[index].quantity >=
              category.quantity
            ) {
              this.langName == "ar"
                ? this.$toasted.show(
                    `تم اختيار العدد الأقصى من الكمية لهذه الفئة`
                  )
                : this.$toasted.show("All items Selected for this category");
            }

            let sortedArray = [
              ...this.ComboPackArray[categoryindex].combo_items,
            ]
              .filter((x) => x.item_id != food.item_id)
              .sort((a, b) => b.quantity - a.quantity);

            for (const _item of sortedArray) {
              let checkIndex = this.ComboPackArray[
                categoryindex
              ].combo_items.findIndex(
                (_c_item) => _c_item.item_id == _item.item_id
              );
              if (
                checkIndex > -1 &&
                this.ComboPackArray[categoryindex].combo_items[checkIndex]
                  .quantity > 0
              ) {
                this.ComboPackArray[categoryindex].combo_items[checkIndex]
                  .quantity--;
                this.ComboPackArray[categoryindex].combo_items[index]
                  .quantity++;
                break;
              }
            }
            // this.$toasted.show("All items Selected for this category");
          } else {
            this.ComboPackArray[categoryindex].combo_items[index].quantity++;
          }
        }
      } else if (type == "minus") {
        if (
          this.ComboPackArray[categoryindex].combo_items[index].quantity > 0
        ) {
          this.ComboPackArray[categoryindex].combo_items[index].quantity--;
        }
      }
    },
    onSaveComboChanges() {
      let errorCount = 0;
      let errMsg = "";
      let finalComboPack = [];
      this.ComboPackArray.forEach((category, categoryIndex) => {
        let checkQuantity = 0;
        let categoryQty =
          category["min_max_setting"] == "Y"
            ? category.min_quantity
            : category.quantity;
        category.combo_items.forEach((items) => {
          checkQuantity += items.quantity;
          if (items.quantity > 0) {
            finalComboPack.push(items);
          }
        });
        if (checkQuantity < categoryQty) {
          errorCount++;
          if (this.langName == "ar") {
            errMsg = `يرجي اختيار ${parseInt(
              categoryQty - checkQuantity
            )} عنصرًا إضافيًا من ${category.alternate_category_name} فئة`;
          } else {
            errMsg = `Please Select ${parseInt(
              categoryQty - checkQuantity
            )} more Item for ${category.category_name} category`;
          }
        }
      });

      if (errorCount > 0) {
        this.$toasted.show(errMsg);
        return false;
      } else {
        this.onSaveComboPack({
          orderIndex: this.comboIndex,
          finalComboPack: finalComboPack,
          combo_pack: this.ComboPackArray,
        });
        // this.$bvModal.hide("comboPackModal");
      }
    },
  },
};
</script>
<style scoped>
.food-img img {
  border-radius: 10px;
}
.newCard {
  padding: 0.45rem;
}
.category-title {
  font-size: 16px;
  text-transform: capitalize;
  font-style: italic;
  font-weight: 500;
}

.category-title-box {
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 5px;
  -webkit-box-shadow: 0 1px 5px 0px lightgrey;
  box-shadow: 0px 1px 1px 0px lightgrey;
}

.combo-item-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
}

.combo-food-card {
  width: 80%;
  height: 170px;
  overflow: hidden;
  position: relative;
  border-radius: var(--posFnbGlobalRadius);
  background-color: #fff;
  box-shadow: 4px 5px 12px -7px;
}

.combo-food-card .food-img {
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-align: center;
  justify-content: center;
  height: calc(100% - 75px);
}

.combo-food-card .food-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.combo-detail-card {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  padding: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-align: center;
  position: absolute;
  background-color: var(--lightblue);
}

.combo-btn-style {
  color: black;
  box-shadow: 1px 3px 10px 1px #817a7a;
  border: none;
  background: white !important;
}

.activeComboItems {
  box-shadow: 0px 10px 19px -2px rgb(56 59 53);
  transform: scale(1.1);
}

.br-20 {
  border-radius: 20px !important;
}

.combo-item-count {
  color: green;
  font-weight: bold;
}

.selectedComboItem-sm {
  position: absolute;
  left: 90%;
  top: 0%;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  background: white;
}

.selectedComboItem {
  position: relative;
  left: 85%;
  top: -98%;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  background: white;
}

.product-name {
  font-weight: bold;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 40px;
}
.combo-modal-wrapper {
  zoom: 0.8;
}

.combo-category-qty-count {
  font-style: normal;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/FnbPopup/CustomizeComboPack.vue